export enum OrderStatus {
    OrderPlaced  = 'OrderPlaced',
    Accepted     = 'Accepted',
    Rejected     = 'Rejected',
    Completed    = 'Completed',
    OnHold       = 'OnHold',
    InProduction = 'InProduction',
    Shipped      = 'Shipped',
    Cancelled    = 'Cancelled',
}

export const OrderStatusLabels: Record<OrderStatus, string> = {
    [OrderStatus.OrderPlaced]:  'Order Placed',
    [OrderStatus.Accepted]:     'Accepted',
    [OrderStatus.Rejected]:     'Rejected',
    [OrderStatus.Completed]:    'Completed',
    [OrderStatus.OnHold]:       'On Hold',
    [OrderStatus.InProduction]: 'In Production',
    [OrderStatus.Shipped]:      'Shipped',
    [OrderStatus.Cancelled]:    'Cancelled',
};

export const OrderStatusBadgeClass: Record<OrderStatus, string> = {
    [OrderStatus.OrderPlaced]:  'badge bg-warning text-dark',
    [OrderStatus.Accepted]:     'badge bg-info text-dark',
    [OrderStatus.Rejected]:     'badge bg-danger',
    [OrderStatus.Completed]:    'badge bg-success',
    [OrderStatus.OnHold]:       'badge bg-secondary',
    [OrderStatus.InProduction]: 'badge bg-primary',
    [OrderStatus.Shipped]:      'badge bg-info',
    [OrderStatus.Cancelled]:    'badge bg-dark',
};

/** Valid next statuses a B2B admin can set, per current status */
export const AllowedTransitions: Partial<Record<OrderStatus, OrderStatus[]>> = {
    [OrderStatus.OrderPlaced]:  [OrderStatus.Accepted, OrderStatus.Rejected, OrderStatus.OnHold],
    [OrderStatus.Accepted]:     [OrderStatus.InProduction, OrderStatus.Cancelled],
    [OrderStatus.OnHold]:       [OrderStatus.Accepted, OrderStatus.Cancelled],
    [OrderStatus.InProduction]: [OrderStatus.Shipped],
    [OrderStatus.Shipped]:      [OrderStatus.Completed],
    [OrderStatus.Rejected]:     [],
    [OrderStatus.Completed]:    [],
    [OrderStatus.Cancelled]:    [],
};
